import { configuredFetchBaseQuery } from '@config/rtkQuery';
import { createApi } from '@reduxjs/toolkit/dist/query/react';

export const didServiceTypeApi = createApi({
  reducerPath: 'didServiceTypeApi',
  baseQuery: configuredFetchBaseQuery(),
  endpoints: (builder) => ({
    getForSelect: builder.query({
      query: () => ({ url: `customer/did-service-type` }),
      transformResponse: (response) => response.results,
      providesTags: ['DidServiceTypes'],
    }),
  }),
});
